module.exports = __webpack_public_path__ + "c78acc54024cd3a68d163ea405be106c.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/photo-backgrounds/national-state-parks/Sequoia National Park1.jpg
// module id = 3349
// module chunks = 0